module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/task-5974974bc2965985ae5227d0d31cbbc7.svg";